import type { AppDispatch } from '../../../store/types';
import { setHighlightedSubclipIds } from './slice';

let currentHighlightTimer: number | undefined;

export const highlightSubclip =
  (subclipAssetIds: readonly string[]) => (dispatch: AppDispatch) => {
    dispatch(setHighlightedSubclipIds([...subclipAssetIds]));
    if (currentHighlightTimer) {
      clearTimeout(currentHighlightTimer);
      currentHighlightTimer = undefined;
    }
    // An empty highlight has nothing to clear later.
    if (subclipAssetIds.length === 0) {
      return;
    }
    currentHighlightTimer = window.setTimeout(() => {
      currentHighlightTimer = undefined;
      dispatch(setHighlightedSubclipIds([]));
    }, 2000);
  };
